import React, { ReactNode, useContext } from 'react'

import styles from './index.module.css'
import { CardContext } from '..'

export interface IFooterProps {
  children: ReactNode
}

export const Footer = (props: IFooterProps) => {
  const { children } = props

  const { variant } = useContext(CardContext)

  return (
    <footer className={styles.container} data-variant={variant}>
      {children}
    </footer>
  )
}

Footer.displayName = 'Card.Footer'
